export function Dashboard() {
  return (
    <div className="trc-page">
      <header className="trc-page-header">
        <p className="trc-eyebrow">Operations</p>
        <h1 className="trc-osw trc-page-title">On the Water Today</h1>
      </header>
      <p className="trc-page-empty">
        Dashboard will surface today's trips by guide, river conditions, open inquiries, recent
        payments, and KPIs once those data sources land in Phase 3.
      </p>
    </div>
  );
}
